export default __webpack_public_path__ + "static/media/future.bfa8ed73.png";